var _regeneratorRuntime = require("/home/trout/static/token-display-app/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/home/trout/static/token-display-app/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/home/trout/static/token-display-app/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/trout/static/token-display-app/node_modules/@babel/runtime/helpers/createClass.js");

/*
  A library for creating SLP tokens with mutable data.

  Implements this specification for mutable data:
  https://github.com/Permissionless-Software-Foundation/specifications/blob/master/ps002-slp-mutable-data.md

*/
var Create = /*#__PURE__*/function () {
  "use strict";

  function Create() {
    var localConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Create);

    // Dependency Injections
    this.wallet = localConfig.wallet;

    if (!this.wallet) {
      throw new Error('Instance of minimal-slp-wallet must be passed as wallet when instantiating get.js library.');
    } // Encapsulate dependencies


    this.bchjs = this.wallet.bchjs; // Bind 'this' object to functions that lose context.

    this.createToken = this.createToken.bind(this);
    this.buildTokenTx = this.buildTokenTx.bind(this);
    this.buildNftTokenTx = this.buildNftTokenTx.bind(this);
    this.createMutableTxid = this.createMutableTxid.bind(this);
  } // Create a new SLP token with mutable data.
  // Three different token types: fungible, group, nft
  // fungible = default, normal Type 1 SLP tokens


  _createClass(Create, [{
    key: "createToken",
    value: function () {
      var _createToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(wif, tokenData, mda, destAddr) {
        var tokenType,
            groupId,
            name,
            ticker,
            documentUrl,
            decimals,
            initialQty,
            mintBatonVout,
            documentHash,
            slpData,
            hex,
            txid,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                tokenType = _args.length > 4 && _args[4] !== undefined ? _args[4] : 'fungible';
                groupId = _args.length > 5 ? _args[5] : undefined;
                _context.prev = 2;
                name = tokenData.name, ticker = tokenData.ticker, documentUrl = tokenData.documentUrl, decimals = tokenData.decimals, initialQty = tokenData.initialQty, mintBatonVout = tokenData.mintBatonVout;
                _context.next = 6;
                return this.createMutableTxid(wif, mda);

              case 6:
                documentHash = _context.sent;
                console.log("documentHash TXID: ".concat(documentHash)); // Wait a couple seconds to allow indexer to update UTXOs.

                _context.next = 10;
                return this.bchjs.Util.sleep(2000);

              case 10:
                // Generate SLP config object
                slpData = {
                  name: name,
                  ticker: ticker,
                  documentUrl: documentUrl,
                  decimals: decimals,
                  initialQty: initialQty,
                  documentHash: documentHash,
                  mintBatonVout: mintBatonVout
                };

                if (!(tokenType === 'nft')) {
                  _context.next = 17;
                  break;
                }

                _context.next = 14;
                return this.buildNftTokenTx(wif, slpData, groupId, destAddr);

              case 14:
                hex = _context.sent;
                _context.next = 20;
                break;

              case 17:
                _context.next = 19;
                return this.buildTokenTx(wif, slpData, destAddr, tokenType);

              case 19:
                hex = _context.sent;

              case 20:
                _context.next = 22;
                return this.wallet.ar.sendTx(hex);

              case 22:
                txid = _context.sent;
                return _context.abrupt("return", txid);

              case 26:
                _context.prev = 26;
                _context.t0 = _context["catch"](2);
                console.error('Error in createToken()');
                throw _context.t0;

              case 30:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 26]]);
      }));

      function createToken(_x, _x2, _x3, _x4) {
        return _createToken.apply(this, arguments);
      }

      return createToken;
    }() // Build a transaction for creating a new Type1 or Group token.

  }, {
    key: "buildTokenTx",
    value: function () {
      var _buildTokenTx = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(wif, slpData, destAddr) {
        var tokenType,
            ecPair,
            address,
            utxos,
            utxo,
            transactionBuilder,
            originalAmount,
            vout,
            txid,
            txFee,
            remainder,
            script,
            _destAddr,
            redeemScript,
            tx,
            hex,
            _args2 = arguments;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                tokenType = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : 'fungible';
                _context2.prev = 1;

                if (!(!wif || typeof wif !== 'string')) {
                  _context2.next = 4;
                  break;
                }

                throw new Error('WIF must be a string');

              case 4:
                if (!(!slpData || typeof slpData !== 'object')) {
                  _context2.next = 6;
                  break;
                }

                throw new Error('slpData must be an object');

              case 6:
                // Generate a key pair from the wif.
                ecPair = this.bchjs.ECPair.fromWIF(wif); // const publicKey = this.bchjs.ECPair.toPublicKey(ecPair).toString('hex')

                address = this.bchjs.ECPair.toCashAddress(ecPair); // Get UTXOs held by the address.
                // const utxos = await this.bchjs.Utxo.get(address)

                _context2.next = 10;
                return this.wallet.getUtxos(address);

              case 10:
                utxos = _context2.sent;

                if (!(utxos.bchUtxos.length === 0)) {
                  _context2.next = 13;
                  break;
                }

                throw new Error('No BCH UTXOs found in wallet.');

              case 13:
                _context2.next = 15;
                return this.bchjs.Utxo.findBiggestUtxo(utxos.bchUtxos);

              case 15:
                utxo = _context2.sent;
                // instance of transaction builder
                transactionBuilder = new this.bchjs.TransactionBuilder();
                originalAmount = utxo.value;
                vout = utxo.tx_pos;
                txid = utxo.tx_hash; // add input with txid and index of vout

                transactionBuilder.addInput(txid, vout); // Set the transaction fee. Manually set for ease of example.

                txFee = 550; // amount to send back to the sending address.
                // Subtract two dust transactions for minting baton and tokens.

                remainder = originalAmount - 546 * 2 - txFee;
                console.log('slpData: ', slpData); // Generate the OP_RETURN entry for an SLP GENESIS transaction.

                if (tokenType === 'group') {
                  script = this.bchjs.SLP.NFT1.newNFTGroupOpReturn(slpData);
                } else {
                  script = this.bchjs.SLP.TokenType1.generateGenesisOpReturn(slpData);
                } // OP_RETURN needs to be the first output in the transaction.


                transactionBuilder.addOutput(script, 0);
                _destAddr = destAddr || address; // Send dust transaction representing the tokens.

                transactionBuilder.addOutput(this.bchjs.Address.toLegacyAddress(_destAddr), 546);

                if (slpData.mintBatonVout !== null) {
                  // Send dust transaction representing minting baton.
                  transactionBuilder.addOutput(this.bchjs.Address.toLegacyAddress(address), 546);
                } // add output to send BCH remainder of UTXO.


                transactionBuilder.addOutput(address, remainder); // Sign the transaction with the HD node.

                transactionBuilder.sign(0, ecPair, redeemScript, transactionBuilder.hashTypes.SIGHASH_ALL, originalAmount); // build tx

                tx = transactionBuilder.build(); // output rawhex

                hex = tx.toHex();
                return _context2.abrupt("return", hex);

              case 36:
                _context2.prev = 36;
                _context2.t0 = _context2["catch"](1);
                console.log('Error in create-token/buildTokenTx()');
                throw _context2.t0;

              case 40:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 36]]);
      }));

      function buildTokenTx(_x5, _x6, _x7) {
        return _buildTokenTx.apply(this, arguments);
      }

      return buildTokenTx;
    }() // Build a transaction for creating an NFT.

  }, {
    key: "buildNftTokenTx",
    value: function () {
      var _buildNftTokenTx = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(wif, slpData, groupId, destAddr) {
        var ecPair, address, utxos, groupUtxos, utxo, transactionBuilder, originalAmount, vout, txid, txFee, remainder, script, _destAddr, redeemScript, tx, hex;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                if (!(!wif || typeof wif !== 'string')) {
                  _context3.next = 3;
                  break;
                }

                throw new Error('WIF must be a string');

              case 3:
                if (!(!slpData || typeof slpData !== 'object')) {
                  _context3.next = 5;
                  break;
                }

                throw new Error('slpData must be an object');

              case 5:
                if (!(!groupId || typeof groupId !== 'string')) {
                  _context3.next = 7;
                  break;
                }

                throw new Error('groupId must be a string');

              case 7:
                // Generate a key pair from the wif.
                ecPair = this.bchjs.ECPair.fromWIF(wif); // const publicKey = this.bchjs.ECPair.toPublicKey(ecPair).toString('hex')

                address = this.bchjs.ECPair.toCashAddress(ecPair); // Get UTXOs held by the address.
                // const utxos = await this.bchjs.Utxo.get(address)

                _context3.next = 11;
                return this.wallet.getUtxos(address);

              case 11:
                utxos = _context3.sent;

                if (!(utxos.bchUtxos.length === 0)) {
                  _context3.next = 14;
                  break;
                }

                throw new Error('No BCH UTXOs found in wallet.');

              case 14:
                groupUtxos = utxos.slpUtxos.group.tokens; // Get the biggest UTXO controlled by the wallet, to pay for tx fees.

                _context3.next = 17;
                return this.bchjs.Utxo.findBiggestUtxo(utxos.bchUtxos);

              case 17:
                utxo = _context3.sent;
                // Filter out the token UTXOs that match the user-provided token ID
                // and contain the minting baton.
                groupUtxos = groupUtxos.filter(function (utxo, index) {
                  if (utxo && // UTXO is associated with a token.
                  utxo.tokenId === groupId && // UTXO matches the token ID.
                  utxo.type === 'token' // UTXO is not a minting baton.
                  ) {
                    return true;
                  }

                  return false;
                }); // console.log(`groupUtxos: ${JSON.stringify(groupUtxos, null, 2)}`)

                if (!(groupUtxos.length === 0)) {
                  _context3.next = 21;
                  break;
                }

                throw new Error('No token UTXOs for the specified Group token could be found.');

              case 21:
                // instance of transaction builder
                transactionBuilder = new this.bchjs.TransactionBuilder();
                originalAmount = utxo.value;
                vout = utxo.tx_pos;
                txid = utxo.tx_hash; // add the NFT Group UTXO as an input. This NFT Group token must be burned
                // to create a Child NFT, as per the spec.

                transactionBuilder.addInput(groupUtxos[0].tx_hash, groupUtxos[0].tx_pos); // add input with txid and index of vout

                transactionBuilder.addInput(txid, vout); // Set the transaction fee. Manually set for ease of example.

                txFee = 550; // amount to send back to the sending address.
                // Subtract two dust transactions for minting baton and tokens.

                remainder = originalAmount - 546 * 2 - txFee; // Generate the OP_RETURN entry for an SLP GENESIS transaction.

                script = this.bchjs.SLP.NFT1.generateNFTChildGenesisOpReturn(slpData); // OP_RETURN needs to be the first output in the transaction.

                transactionBuilder.addOutput(script, 0);
                _destAddr = destAddr || address; // Send dust transaction representing the tokens.

                transactionBuilder.addOutput(this.bchjs.Address.toLegacyAddress(_destAddr), 546); // add output to send BCH remainder of UTXO.

                transactionBuilder.addOutput(address, remainder); // Sign the transaction with the HD node.

                transactionBuilder.sign(0, ecPair, redeemScript, transactionBuilder.hashTypes.SIGHASH_ALL, groupUtxos[0].value);
                transactionBuilder.sign(1, ecPair, redeemScript, transactionBuilder.hashTypes.SIGHASH_ALL, originalAmount); // build tx

                tx = transactionBuilder.build(); // output rawhex

                hex = tx.toHex();
                return _context3.abrupt("return", hex);

              case 41:
                _context3.prev = 41;
                _context3.t0 = _context3["catch"](0);
                console.log('Error in create-token/buildTokenTx()');
                throw _context3.t0;

              case 45:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 41]]);
      }));

      function buildNftTokenTx(_x8, _x9, _x10, _x11) {
        return _buildNftTokenTx.apply(this, arguments);
      }

      return buildNftTokenTx;
    }() // This function is called by createToken, in order to generate the TXID
    // for the mutable data. This TX points to the mutable data address (mda),
    // and the TXID is used in the 'documentHash' property of the SLP token.

  }, {
    key: "createMutableTxid",
    value: function () {
      var _createMutableTxid = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(wif, mda) {
        var ecPair, address, utxos, utxo, transactionBuilder, originalAmount, vout, txid, fee, dust, script, data, redeemScript, tx, hex, txidStr;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                if (!(!wif || typeof wif !== 'string')) {
                  _context4.next = 3;
                  break;
                }

                throw new Error('WIF must be a string');

              case 3:
                if (!(!mda || typeof mda !== 'string')) {
                  _context4.next = 5;
                  break;
                }

                throw new Error('mda must be a string');

              case 5:
                // Generate a key pair from the wif.
                ecPair = this.bchjs.ECPair.fromWIF(wif); // const publicKey = this.bchjs.ECPair.toPublicKey(ecPair).toString('hex')

                address = this.bchjs.ECPair.toCashAddress(ecPair); // Get UTXOs held by the address.

                _context4.next = 9;
                return this.wallet.getUtxos(address);

              case 9:
                utxos = _context4.sent;

                if (!(utxos.bchUtxos.length === 0)) {
                  _context4.next = 12;
                  break;
                }

                throw new Error('No BCH UTXOs found in wallet.');

              case 12:
                _context4.next = 14;
                return this.bchjs.Utxo.findBiggestUtxo(utxos.bchUtxos);

              case 14:
                utxo = _context4.sent;
                // instance of transaction builder
                transactionBuilder = new this.bchjs.TransactionBuilder();
                originalAmount = utxo.value;
                vout = utxo.tx_pos;
                txid = utxo.tx_hash; // add input with txid and index of vout

                transactionBuilder.addInput(txid, vout); // TODO: Compute the 1 sat/byte fee.

                fee = 500;
                dust = 546; // Generate the OP_RETURN data

                script = [this.bchjs.Script.opcodes.OP_RETURN, Buffer.from(JSON.stringify({
                  mda: mda
                }))]; // Compile the script array into a bitcoin-compliant hex encoded string.

                data = this.bchjs.Script.encode(script); // Add the OP_RETURN output.

                transactionBuilder.addOutput(data, 0); // Send dust to the MSP address to cryptographically link it to this TX.

                transactionBuilder.addOutput(mda, dust); // Send change back to originating address.

                transactionBuilder.addOutput(address, originalAmount - fee - dust); // Sign the transaction with the HD node.

                transactionBuilder.sign(0, ecPair, redeemScript, transactionBuilder.hashTypes.SIGHASH_ALL, originalAmount); // build tx

                tx = transactionBuilder.build(); // output rawhex

                hex = tx.toHex(); // Broadcast transaction to the network
                // const txidStr = await this.bchjs.RawTransactions.sendRawTransaction(hex)

                _context4.next = 32;
                return this.wallet.ar.sendTx(hex);

              case 32:
                txidStr = _context4.sent;
                return _context4.abrupt("return", txidStr);

              case 36:
                _context4.prev = 36;
                _context4.t0 = _context4["catch"](0);
                console.error('Error in createMutableTxid()');
                throw _context4.t0;

              case 40:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 36]]);
      }));

      function createMutableTxid(_x12, _x13) {
        return _createMutableTxid.apply(this, arguments);
      }

      return createMutableTxid;
    }()
  }]);

  return Create;
}();

module.exports = Create;